import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import reportActions from '../../report/reportActions';

import { Button } from '../../components/buttons';
import { Page, PageContent, PageHeader } from '../../components/common';
import { BirthDatePicker } from '../../components/forms';
import Utils, { SecurityRoles } from '../../common/utils';
import { ensureUserHasRoleAdminSite } from '../../auth/authComponents';

interface Props {
	actions: any;
	history: any;
	users: UserDetails[];
}
interface State {
	fromDate: string | undefined;
	toDate: string | undefined;
}
class UserActivityPage extends React.Component<Props, State> {
	state = {
		fromDate: undefined,
		toDate: undefined
	};

	onFilterChange = (e: any) => {
		this.setState({ [e.target.name]: e.target.value });
	}

	// not called by anywhere??
	preview = () => {
		this.props.actions.fetchUserActivities(this.state.fromDate, this.state.toDate);
	}

	download = () => {
		this.props.actions.fetchUserActivities(this.state.fromDate, this.state.toDate)
			.then(() => {
				const formattedUsers = this.formatData(this.props.users);
				Utils.downloadCsv(formattedUsers, 'UserActivity.csv');
			});
	}
	formatData = (users: UserDetails[]) => {
		const formattedUsers = users.map(u => {
			var policies = u.policies ? u.policies.map(p => p.number) : [];
			return {
				Name: u.fullName,
				Email: u.email,
				['Sex']: Utils.formatFirstUpperCase(u.gender!),
				Birthdate: Utils.formatDate(u.birthDate),
				['Sign up date']: Utils.formatDate(u.createdDate),
				Policies: policies
			};
		});

		return formattedUsers;
	}

	render() {
		return (
			<Page title="User activity">
				<PageContent>
					<PageHeader title="User activity" />
					<h2 className="form-fieldset-title">Report Filters</h2>
					<div className="form-fieldset mb-4">
						<div className="row">
							<BirthDatePicker
								className="col-sm-6 col-lg-3"
								labelText="From"
								name="fromDate"
								placeholder="YYYY-MM-DD"
								value={this.state.fromDate}
								onChange={this.onFilterChange}
								required={true}
							/>
							<BirthDatePicker
								className="col-sm-6 col-lg-3"
								labelText="To"
								name="toDate"
								placeholder="YYYY-MM-DD"
								value={this.state.toDate}
								onChange={this.onFilterChange}
								required={true}
							/>
						</div>
						<div className="row col-sm-12">
							<Button
								className="btn-primary"
								onClick={this.download}
								disabled={this.state.fromDate === null || this.state.toDate === null ||
													!this.state.fromDate || !this.state.toDate}
							>
								<span className="align-middle mx-2">Download</span>
							</Button>
						</div>
					</div>
				</PageContent>
			</Page>
		);
	}
}
function mapStateToProps(state: any) {
	return {
		users: state.report.users,
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...reportActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
const connectedPage = connect(mapStateToProps, mapDispatchToProps)(UserActivityPage);
const roles = [SecurityRoles.Administrator, SecurityRoles.Agent];
export default ensureUserHasRoleAdminSite(connectedPage as any, roles);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/reports/UserActivityPage.tsx